export default {
  app: {
    paddingTopBottom: "5px",
  },
  aside: {
    width: "240px",
  },
  font: {
    legend: "chuan qi",
    youshe: "you she",
    dot: "Dotted Songti Square",
    MicrosoftYaHei: "Microsoft YaHei",
  },
  fontColor: "#555",
  titleColor: "#000",
  fontSize: {
    xxlarge: "32px",
    large: "20px",
    slarge: "18px",
    normal: "16px",
    lsmall: "14px",
    small: "13px",
    xsmall: "12px",
  },
  blue: "#3cf",
  infoBlue: "#428bca",
  hashBlue: "#0096c7",
  red: "#e85d04",
  green: "#22863a",
  weakRed: "#f3722c",
  black: "#555",
  dark: "#222",
  gray: "#bbb",
  weakGray: "#ddd",
  middleGray: "#d1d5da",
  darkGray: "#ccc",
  infoGray: "#586069",
  quoteGray: "#6a737d",
  quoteBorderGray: "#dfe2e5",
  borderGray: "#e1e4e8",
  white: "#fff",
  whiteSmoke: "#edebeb",
  backgroundColor: "#eee",
  secondBackgroundColor: "#fff",
  // 遮罩的颜色
  maskColor: "rgba(0, 0, 0, 0.3)",
  boxShadow: `0 2px 2px 0 rgba(0, 0, 0, 0.12),
  0 3px 1px -2px rgba(0, 0, 0, 0.06), 0 1px 5px 0 rgba(0, 0, 0, 0.12),
  0 -1px 0.5px 0 rgba(0, 0, 0, 0.09)`,
  boxShadowInner: `0px 0px 3px 1px rgba(0, 0, 0, 0.2)`,
  navbarBoxShadow: `inset 0 -1px 0 #e1e4e8`,
};
